import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
declare global {
  interface Window {
    CI360: any;
  }
}

@Component({
  selector: 'app-threesixty',
  templateUrl: './threesixty.component.html',
  styleUrls: ['./threesixty.component.css']
})
export class ThreesixtyComponent implements OnInit {

  @Input() images: any[];
  @Output() close = new EventEmitter();

  constructor() { }

  ngOnInit(): void {
    const el = document.getElementById('gurkha-suv');

    el.setAttribute('data-image-list-x', JSON.stringify(this.images))
    el.setAttribute('data-amount-x', this.images.length.toString())

    window.CI360.init();
  }

  onClose() {
    this.close.emit();
  }

}
